export default "__VITE_ASSET__CA6bu5Kq__"